import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { connectStripeAccount } from '../services/stripeConnectService';
import { getSession } from '../lib/supabase';

export default function StripeConnect() {
  const navigate = useNavigate();
  const { user, role } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user?.id || (role !== 'agent' && role !== 'admin')) {
      navigate('/dashboard', { replace: true });
      return;
    }

    let cancelled = false;

    const start = async () => {
      const session = await getSession();
      const { data, error: err } = await connectStripeAccount(session?.access_token ?? null);

      if (cancelled) return;

      if (err) {
        setError(err.message || 'Could not start Stripe connection');
        return;
      }

      if (data?.url) {
        window.location.href = data.url;
        return;
      }

      setError('No redirect URL received');
    };

    start();

    return () => { cancelled = true; };
  }, [user?.id, role, navigate]);

  if (error) {
    return (
      <div className="min-h-[40vh] flex flex-col items-center justify-center p-6">
        <p className="text-red-600 mb-4">{error}</p>
        <button
          type="button"
          onClick={() => navigate('/dashboard')}
          className="px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700"
        >
          Back to Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-[40vh] flex flex-col items-center justify-center p-6">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-blue-600 mb-4" />
      <p className="text-slate-600">Redirecting to Stripe…</p>
    </div>
  );
}
